import Vue from 'vue'

export async function getCaminos(context, [access_token, con_loading]) {
    
    try {
        if (access_token) {
            if (con_loading){
                context.commit('setLoading', true, { root: true })
            }
            const response = await Vue.axios({
                method: 'GET',
                url: '/caminos',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
            console.log('caminos:', response.data.data)
            context.commit('caminos/setCaminos', response.data.data, { root: true })
        }

    } catch (e) {
    } finally {
        if (con_loading){
            context.commit('setLoading', false, { root: true })
        }
    }
}


export async function getCamino(context, [access_token, id, con_loading]) {
    
    try {
        if (access_token) {
            if (con_loading){
                context.commit('setLoading', true, { root: true })
            }
            const response = await Vue.axios({
                method: 'GET',
                url: '/caminos/' + id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
            console.log('camino:', response.data.data)
            if (response.status == 200) {
               context.commit('caminos/setCaminoSelec', response.data.data, { root: true })
            }
        }

    } catch (e) {
    } finally {
        if (con_loading){
            context.commit('setLoading', false, { root: true })
        }
    }
}

export async function crearCamino(context, [access_token, modelCamino]) {
    try {

        if (access_token) {
           // context.commit('setLoading', true, { root: true })
            const response = await Vue.axios({
                method: 'POST',
                url: '/caminos',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelCamino
            })
        }

    } catch (e) {
    } finally {
     //  context.commit('setLoading', false, { root: true })
    }
}

export async function updateCamino(context, [access_token, modelCamino]) {
    try {
        if (access_token) {
          
            const response = await Vue.axios({
                method: 'PUT',
                url: '/caminos/' + modelCamino.id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelCamino
            })
            if (response.status == 200) {
                context.commit('caminos/actListCaminos', response.data.data, { root: true })
                context.commit('categorias/actListCaminosFromCategorias', response.data.data, { root: true })
            }
           return response;
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
     // context.commit('setLoading', false, { root: true })
    }
}

export async function eliminarCamino(context, [access_token, camino_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'DELETE',
                url: '/caminos/' + camino_id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
           if (response.status == 200) {
            context.commit('caminos/actDeleteListCaminos', camino_id, { root: true })
            context.commit('categorias/actDeleteListCaminosFromCategorias', camino_id, { root: true })
            
           }
           return response;
        }
    } catch (e) {
    } finally {
      // context.commit('setLoading', false, { root: true })
    }
}


